import { Grid, InputLabel, MenuItem, Select, Typography, FormControl, Autocomplete, TextField } from '@mui/material';
import React, { Component } from 'react'
import SFTabs from '../../SFComponents/SFTabs/SFTabs';
import "./style.css"
import SFAssignmentDetail from './components/SFAssignmentDetail';
import SFTopicDetail from './components/SFTopicDetail';
import SFMySetDetail from './components/SFMySetDetail';
import { AppContext } from '../../../AppContext';
import SFPracticeDetail from './components/SFPracticeDetail';
import { AppProperties, AppSetting } from '../../../common/functions';
import RecommendForPracticeWidget from '../SFDashboard/widgets/RecommendForPracticeWidget';
import SFPracticeSetCart from './components/SFPracticeSetCart';
import ApiRequestService from '../../../components/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import SFStudentSearch from '../../SFComponents/SFStudentSearch/SFStudentSearch';

class SFPerformanceAnalytics extends Component {

    appProperties = AppProperties();
    appSetting = AppSetting();

    static contextType = AppContext

    constructor(props) {
        super(props);

        // this.params = new URLSearchParams(this.props.location.search)

        this.state = {
            tabs: [
                { id: 0, value: "By Assignments" },
                { id: 1, value: "By Topics" },
                { id: 2, value: "My Sets" },
            ],
            activeTabIndex: 0,
            activeQuizID: 0,
            count: 0,
            isInstructor: false,
            instructorCourses: [],
            selectedInstructorCourseID: null,
            selectedInstructorCourse: null,

            instructorSections: [],
            selectedInstructorSectionID: null,

            instructorStudents: [],
            selectedStudentUserName: null,
            selectedStudentFullName: null,
            // courseID: this.params.get("courseID") ? parseInt(this.params.get("courseID")) : null,

            savedAssignmentsForAllStudents: {},
            savedTopicsForAllStudents: {},
            studentModeState: false,
        }

    }

    onTabClick = (tabIndex) => {
        this.setState({
            activeTabIndex: tabIndex,
            activeQuizID: null,
            count: 0,
        })
    }

    getInstructorCourses = () => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses'
        }).then(res => {
            console.debug('course response ', res);

            if (res && res.data && res.data.data) {
                this.setState({
                    instructorCourses: res.data.data.course_names,
                })
            } else {
                if (res.data.message !== null && res.data.message !== '') {
                    NotificationManager.error(res.data.message, 'ERROR', 3000);
                }
            }
        });
    }
    getInstructorCourseSections = (courseID) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: {
                course_id: courseID,
            }
        }).then(res => {
            console.debug('sections response ', res);

            if (res && res.data && res.data.data) {
                this.setState({
                    instructorSections: res.data.data.section_names,
                })
            } else {
                if (res.data.message !== null && res.data.message !== '') {
                    NotificationManager.error(res.data.message, 'ERROR', 3000);
                }
            }
        });
    }

    getInstructorCourseSectionStudents = (courseID, sectionID) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllStudentEnrollmentByID',
            data: {
                course_id: courseID,
                section_id: sectionID,
            }
        }).then(res => {
            console.debug('students response ', res);

            if (res && res.data && res.data.data) {
                this.setState({
                    instructorStudents: res.data.data,
                })
            } else {
                if (res.data.message !== null && res.data.message !== '') {
                    NotificationManager.error(res.data.message, 'ERROR', 3000);
                }
            }
        });
    }

    componentDidMount() {

        const params = new URLSearchParams(window.location.search);
        const tabName = params.get('tabName');
        const quizID = params.get('quizID');

        if (this.appProperties && this.appProperties.currentUserData && this.appProperties.currentUserData.role != "0") {
            this.setState({
                isInstructor: true,
            })
            this.getInstructorCourses();
        }

        if (this.appProperties && this.appProperties.enableLTI) {

            let newTabs = [{ id: 3, value: "Recommended For Practice" }, ...this.state.tabs];
            this.setState({
                tabs: newTabs,
                activeTabIndex: 3,
            })
        } else {
            let index = 0;
            if (tabName && tabName === "sets") {
                index = 2;
            }

            this.setState({
                activeTabIndex: index,
                activeQuizID: quizID ? parseInt(quizID) : 0,
            })
        }

        const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    componentDidUpdate() {
        if (this.state.studentModeState !== this.context.studentMode) {
            console.debug("CLEAR ALL");
            this.setState({
                studentModeState: this.context.studentMode,
                
                selectedInstructorCourseID: null,
                selectedInstructorCourse: null,
                selectedStudentUserName: null,
                selectedStudentFullName: null,
                selectedInstructorSectionID: null,
                instructorSections: [],
                instructorStudents: [],
            })
        }
    }

    /* handleSelectCategory = (cat) => {
        // check if category is already selected

        let alreadPresent = this.state.selectedCategories?.findIndex(category => {
            let catKey1 = `${category.subjectID}_${category.topicID}_${category.id}`;
            let catKey2 = `${cat.subjectID}_${cat.topicID}_${cat.id}`;
            return catKey1 === catKey2;
        })

        if (alreadPresent && alreadPresent > -1) {
            NotificationManager.warning("This cat is alread added");
        } else {
            this.setState({
                selectedCategories: [...this.state.selectedCategories, cat]
            })
        }
    }

    handleRemoveCategory = (cat) => {
        let key = `${cat.subjectID}_${cat.topicID}_${cat.id}`
        let index = this.state.selectedCategories.findIndex(selectedCat => {
            return `${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.id}` === key
        })

        if (index >= 0) {
            let updatedCategories = this.state.selectedCategories;
            updatedCategories.splice(index, 1)
            this.setState({
                selectedCategories: updatedCategories,
            })
        }
    } */


    handleUpdateCount = (count) => {
        this.setState({
            count: count,
        })
    }

    getUI(tabIndex, selectedCourse, onAddActivityLog, selectedCategories, handleAddCategory, handleRemoveCategory) {
        let savedKey = `${selectedCourse.course_id}_${selectedCourse.section_id}`;
        if (tabIndex === 0) { // By Assignments
            return <SFAssignmentDetail
                handleAddCategory={handleAddCategory}
                handleRemoveCategory={handleRemoveCategory}
                selectedCategories={selectedCategories}
                selectedCourse={selectedCourse}
                selectedInstructorSectionID={this.state.selectedInstructorSectionID}
                handleUpdateCount={this.handleUpdateCount}
                onAddActivityLog={onAddActivityLog}
                handleRoute={this.props.handleRoute}
                selectedStudentUserName={!this.context.studentMode ? this.state.selectedStudentUserName : ""}
                isInstructor={this.state.isInstructor && !this.context.studentMode}
                savedAssignmentsForAllStudents={this.state.savedAssignmentsForAllStudents[savedKey]}
                updateSavedAssignmentsForAllStudents={(mkey, dataArr) => {
                    let newData = this.state.savedAssignmentsForAllStudents;
                    newData[mkey] = dataArr;
                    this.setState({
                        savedAssignmentsForAllStudents: newData
                    })
                }}
            />
        } else if (tabIndex === 1) { // By Topics
            return <SFTopicDetail
                handleAddCategory={handleAddCategory}
                handleRemoveCategory={handleRemoveCategory}
                selectedCategories={selectedCategories}
                selectedInstructorSectionID={this.state.selectedInstructorSectionID}
                selectedCourse={selectedCourse}
                handleUpdateCount={this.handleUpdateCount}
                onAddActivityLog={onAddActivityLog}
                handleRoute={this.props.handleRoute}
                selectedStudentUserName={!this.context.studentMode ? this.state.selectedStudentUserName : ""}
                isInstructor={this.state.isInstructor && !this.context.studentMode}
                savedTopicsForAllStudents={this.state.savedTopicsForAllStudents[savedKey]}
                updateSavedTopicsForAllStudents={(mkey, dataArr) => {
                    let newData = this.state.savedTopicsForAllStudents;
                    newData[mkey] = dataArr;
                    this.setState({
                        savedTopicsForAllStudents: newData
                    })
                }}
            />
        } else if (tabIndex === 3) { // Recommended For Practice
            return (
                <div style={{
                    width: "400px",
                    maxHeight: "500px",
                    height: 'calc(100% - 80px)',
                }}>
                    <RecommendForPracticeWidget
                        {...this.props}
                        isLTI={true}
                        onAddActivityLog={onAddActivityLog}
                        course={selectedCourse}
                        isInstructor={this.state.isInstructor && !this.context.studentMode}
                    />
                </div>
            )
        }
        return <SFMySetDetail
            handleAddCategory={handleAddCategory}
            handleRemoveCategory={handleRemoveCategory}
            selectedCategories={selectedCategories}
            selectedCourse={selectedCourse}
            handleUpdateCount={this.handleUpdateCount}
            onAddActivityLog={onAddActivityLog}
            handleRoute={this.props.handleRoute}
            activeQuizID={this.state.activeQuizID}
            selectedStudentUserName={!this.context.studentMode ? this.state.selectedStudentUserName : ""}
            isInstructor={this.state.isInstructor && !this.context.studentMode}
        />

    }

    showPracticeDetail = (selectedCourse, studentMode) => {
        let val = selectedCourse && selectedCourse.enable_practice_and_performance === 1;
        if (this.state.isInstructor && !studentMode) {
            return val && this.state.selectedStudentUserName;
        }
        return val;
    }

    showPracticeAndAnalyticsDetail = (selectedCourse, studentMode) => {
        let val = selectedCourse && selectedCourse.enable_practice_and_performance === 2;
        if (this.state.isInstructor && !studentMode) {
            return val && this.state.selectedStudentUserName;
        }
        return val;
    }

    showTabs = (selectedCourse, studentMode) => {
        if (selectedCourse?.enable_practice_and_performance == 0) return false;
        let val = selectedCourse && selectedCourse.enable_practice_and_performance !== 1;
        if (this.state.isInstructor && !studentMode) {
            return val && this.state.selectedStudentUserName;
        }
        return val;
    }

    getTitle = (selectedCourse, studentMode) => {
        if (selectedCourse?.enable_practice_and_performance == 0) return null;
        if (this.state.isInstructor && !studentMode) {
            return selectedCourse && this.state.selectedStudentUserName ? (selectedCourse.enable_practice_and_performance === 1 ? "Practice" : "Practice & Analytics") : null;;
        }
        return selectedCourse ? (selectedCourse.enable_practice_and_performance === 1 ? "Practice" : "Practice & Analytics") : null;
    }

    render() {

        let { selectedCourse, onAddActivityLog,
            selectedCategories, handleAddCategory, handleRemoveCategory,
            studentMode
        } = this.context;

        console.debug("selectedCourse BEFORE", selectedCourse, !studentMode)
        if (this.state.isInstructor && !studentMode) {
            onAddActivityLog = () => { };
            selectedCourse = this.state.selectedInstructorCourse
        }
        console.debug("selectedCourse AFTER", selectedCourse)

        if (selectedCourse && selectedCourse.enable_practice_and_performance === 0 && !this.state.isInstructor) {
            return (
                <div className='sf-fixed-center'>
                    <Typography fontSize={24} fontWeight={500}>
                        Sorry! This course does not include any practice or performance activities.
                    </Typography>
                </div>
            )
        }

        return (
            <div className='px-3 pt-3 sf-pa-page position-relative' style={{
                height: this.state.isInstructor && !studentMode ? "calc(100% - 100px)" : "calc(100% - 75px)"
            }}>

                {this.state.isInstructor && !studentMode ?
                    <div className='mb-2'>
                        <Grid container style={{ height: '100%', position: 'relative' }}>
                            <Grid item gap={2} >
                                <FormControl sx={{ m: 1, minWidth: 150, maxWidth: 150 }}>
                                    <InputLabel id="inst-courses">Courses</InputLabel>
                                    <Select
                                        labelId="inst-courses"
                                        id="inst-courses-id"
                                        onChange={(event) => {
                                            let courseID = event.target.value;
                                            let course = this.state.instructorCourses.find(c => c.course_id === courseID);
                                            this.setState({
                                                selectedInstructorCourseID: courseID,
                                                selectedInstructorCourse: course,
                                                selectedStudentUserName: null,
                                                selectedStudentFullName: null,
                                                selectedInstructorSectionID: null,
                                                instructorSections: [],
                                                instructorStudents: [],
                                            })
                                            this.getInstructorCourseSections(courseID)
                                        }}
                                        value={this.state.selectedInstructorCourseID}
                                        label="Courses"
                                    >
                                        {this.state.instructorCourses?.map(course => {
                                            return <MenuItem key={course.course_id} value={course.course_id}>{course.course_name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {this.state.selectedInstructorCourseID ?
                                <Grid item >
                                    <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 250 }}>
                                        <InputLabel id="inst-sections">Sections</InputLabel>
                                        <Select
                                            labelId="inst-sections"
                                            id="inst-sections-id"
                                            onChange={(event) => {
                                                let courseID = this.state.selectedInstructorCourseID;
                                                let sectionID = event.target.value;

                                                let course = this.state.instructorCourses.find(c => c.course_id === courseID);
                                                let section = this.state.instructorSections.find(s => s.section_id === sectionID);
                                                this.setState({
                                                    selectedInstructorSectionID: sectionID,
                                                    selectedStudentUserName: null,
                                                    selectedStudentFullName: null,
                                                    selectedInstructorCourse: {
                                                        ...course,
                                                        ...section,
                                                    },
                                                    instructorStudents: [],
                                                })
                                                this.getInstructorCourseSectionStudents(courseID, sectionID);
                                            }}
                                            value={this.state.selectedInstructorSectionID}
                                            label="Sections"
                                        >
                                            {this.state.instructorSections?.map(section => {
                                                return <MenuItem key={section.section_id} value={section.section_id}>{section.section_name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                : null}
                            {this.state.selectedInstructorSectionID ?
                                <Grid item>
                                    <SFStudentSearch
                                        hideSelectAll={false}
                                        students={this.state.instructorStudents}
                                        selectedStudentUserName={this.state.selectedStudentUserName}
                                        selectedStudentFullName={this.state.selectedStudentFullName}
                                        handleStudentSelect={(userName, fullName) => {
                                            if (userName === "all" && this.state.activeTabIndex === 2) {
                                                this.setState({
                                                    activeTabIndex: 0,
                                                })
                                            }
                                            this.setState({
                                                selectedStudentUserName: userName,
                                                selectedStudentFullName: fullName
                                            })
                                        }}
                                    />
                                </Grid>
                                : null}

                            <Grid item>
                                <div className='h-100 w-100 d-flex flex-column justify-content-center align-items-start'>
                                    <Typography color='primary' fontSize={24} fontWeight={600}>{
                                        this.state.selectedStudentFullName === "all" ? "All Students" : this.state.selectedStudentFullName
                                    }</Typography>
                                    <div>
                                        {this.state.selectedStudentFullName === "all" ? <div>(Mean accuracy & Median time for mastery)</div> : null}
                                    </div>
                                </div>
                            </Grid>

                        </Grid>
                    </div>
                    : null}
                {
                    (selectedCourse && selectedCourse.enable_practice_and_performance === 0) ?
                        (
                            <div className='sf-fixed-center'>
                                <Typography fontSize={24} fontWeight={500}>
                                    Sorry! This course does not include any practice or performance activities.
                                </Typography>
                            </div>
                        )
                        : null
                }

                <div className='d-flex justify-content-start align-items-center mb-3'>
                    <Typography fontSize={20} fontWeight="bold">
                        {this.getTitle(selectedCourse, studentMode)}

                    </Typography>
                    {/* Tabs */}
                    {this.showTabs(selectedCourse, studentMode) ?
                        <div className='ml-2' style={{ height: '50px' }}>
                            <SFTabs
                                tabs={this.state.tabs}
                                activeTabIndex={this.state.activeTabIndex}
                                onTabClick={this.onTabClick}
                                count={this.state.count}
                                onAddActivityLog={onAddActivityLog}
                                selectedStudentUserName={this.state.selectedStudentUserName}
                                studentMode={this.context.studentMode}
                            />
                        </div>
                        : null}
                </div>


                {/* <SFCommonTabDetail 
                     handleSelectCategory={this.handleSelectCategory}
                     handleRemoveCategory={this.handleRemoveCategory}
                     selectedCategories={this.state.selectedCategories}
                     selectedCourse={selectedCourse}
                     handleUpdateCount={this.handleUpdateCount}
                     onAddActivityLog={onAddActivityLog}
                     handleRoute={this.props.handleRoute}
                     activeTabIndex={this.state.activeTabIndex}
                /> */}
                {this.showPracticeDetail(selectedCourse, studentMode) ?
                    <SFPracticeDetail
                        selectedCourse={selectedCourse}
                        handleRoute={this.props.handleRoute}
                        onAddActivityLog={onAddActivityLog}
                        selectedStudentUserName={!this.context.studentMode ? this.state.selectedStudentUserName : ""}
                        isInstructor={this.state.isInstructor && !this.context.studentMode}
                    />
                    : null}

                {this.showPracticeAndAnalyticsDetail(selectedCourse, studentMode) ?

                    this.getUI(this.state.activeTabIndex, selectedCourse, onAddActivityLog, selectedCategories, handleAddCategory, handleRemoveCategory)

                    : null}

                {selectedCourse && selectedCourse.enable_practice_and_performance !== 1 && this.state.activeTabIndex !== 2 ?
                    <SFPracticeSetCart
                        handleRemoveCategory={handleRemoveCategory}
                        selectedCategories={selectedCategories}
                        handleRoute={this.props.handleRoute}
                        onAddActivityLog={onAddActivityLog}
                    />
                    : null}

            </div>
        )
    }
}

export default SFPerformanceAnalytics;